<template>
  <div class="mobWrapper">
    <header class="header">
      <div class="page">
        <NuxtLink to="/" class="branding"><img src="/images/wpLogo.svg" alt="logo" ></NuxtLink>
      </div>
    </header>
    <slot/>
  </div>
</template>
<script setup lang="ts">
useHead({
  bodyAttrs: {
    class: 'body__login'
  }
})
</script>
<style>
</style>